import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import { YinzCamSignonServerToken } from "yinzcam-signon";

@injectable()
export class YinzCamSignonServerProfile extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamSignonServerToken) server) {
    super({ server, defaultPath: '/profile2/user/combined/query?fields=image_url,first_name,last_name,email' });
  }

  protected processResponse(response: YinzCamAPIResponse): object | any[] {
    const data = response?.data as any;    
    console.log('yinzcamSignonServerProfile: ', data, response)
    return data;
  }
}
